var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-image',{ref:_vm.id,attrs:{"preview-src-list":_vm.value,"src":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }